<div class="subsection-right-item" *ngIf="selectedSection != undefined">
  <ion-button class="app-large-btn" [disabled]="selectedSection.sectionName == ''" shape="round" fill="outline" color="primary"
   (click)="addNewSection()">
    {{ 'New Subsection' | translate }}
    <ion-icon slot="start" color="primary" name="add-circle-outline"></ion-icon>
  </ion-button>
</div>
<div *ngIf="subSections.length == 0" class="empty-subsection">
  <img src="/assets/images/Group 20605.svg" alt="empty-subsection" class="empty-subsection-img">
</div>
<div class="subsection-block " *ngIf="subSections.length > 0">
  <div class="subsection-container" *ngFor="let subSection of subSections; let i = index">
    <!-- Render the subsection name -->
    <div class="subsection-left-item">
    <div class="subsection-name">
      <input
        id="subsection"
        type="text"
        placeholder="{{ 'enter_subsection_name' | translate }}"
        [(ngModel)]="subSection.subSectionName"
        class="subsection-input"
      />
    <ion-icon slot="end" color="primary" (click)="deleteSubsection(subSection, i)" name="trash-outline" class="trash-icon "></ion-icon>
    </div>
  </div>

  <!-- Render steps only if they exist for the subsection -->
  <div class="accordion-card" *ngFor="let step of subSection.steps; let j = index">
    <ion-card class="accordion-block">
      <ion-item button (click)="toggleAccordion(step, j)">
        <ion-label>{{ step.stepBody }}</ion-label>
        <ion-icon slot="end" [name]="step.accordionOpen ? 'chevron-up' : 'chevron-down'"></ion-icon>
        <ion-button class="app-large-btn margin-12" shape="round" *ngIf="step.answers.length > 0 && step.answers[0]?.selectedValue !=''" fill="outline" [ngClass]="step.answers[0]?.selectColorClass">
        {{fnGetOptionName(step.answers[0]?.selectedValue)}}
        </ion-button>
      </ion-item>
  
      <!-- Render the content when the accordion is open -->
      <div *ngIf="step.accordionOpen" class="accordion-content">
        <div class="question-container">
          <ion-label>{{ 'Question' | translate }} *</ion-label>
          <ion-item lines="none">
            <ion-textarea placeholder="{{ 'Add a Question' | translate }}" [(ngModel)]="step.stepBody">
            </ion-textarea>
          </ion-item>
        </div>
  
        <ion-list class="radio-buttons-row">
          <ion-radio-group [ngModel]="getAnswer(step)"
          (ionChange)="onRadioSelectionChanged($event,step)"
           name="compliance">
            <div class="radio-item" *ngFor="let option of complianceOptions">
              <ion-radio slot="start" [value]="option.value"></ion-radio>
              <ion-label>{{ option.label | translate }}</ion-label>
            </div>
          </ion-radio-group>
        </ion-list>
  
        <div class="question-container">
          <ion-label>{{ 'Notes' | translate }}</ion-label>
          <ion-item lines="none">
            <ion-textarea name="notes" [(ngModel)]="step.notes"></ion-textarea>
            <ion-icon name="lock-closed-outline" class="lock-icon" color="success"></ion-icon>
          </ion-item>
        </div>
        <div class="button-container">
          <ion-button class="app-large-btn float-left margin-top-12" shape="round" fill="outline" color="primary"
            (click)="addHazardDetails(i,step)">
            {{ 'Add Hazard Details' | translate }}
          </ion-button>
          <div *ngIf="step.answers[0].hazard">
            <ion-label class="subsection-input">{{ 'Hazards' | translate }}</ion-label>
            <ion-row *ngFor="let hazard of step.answers[0].hazardDetails; let i=index">
              <ion-col size="11" (click)="editHazard(hazard,step)">
                <ion-card class="list-card">
                  <ion-row >
                    <ion-col >
                      <ion-label>{{hazard.name}}</ion-label>
                    </ion-col>                  
                  </ion-row>
                </ion-card>
              </ion-col>
              <ion-col size="1">
                <ion-icon class="trash-icon delete-icon-transition" (click)="deleteRoadmapConfirmation(roadmap,i)" tooltip="{{'Delete roadmap' | translate }}"
                  placement="bottom" name="trash-outline">
                </ion-icon>
              </ion-col>
            </ion-row>
        </div>
        </div>
      </div>
    </ion-card>
    <ion-icon slot="end" color="primary" (click)="deleteStep(step, j, $event)" name="trash-outline" class="trash-icon "></ion-icon>
  </div>
  <div>
    <ion-button class="app-btn margin-right-16" shape="round" fill="outline" color="primary" (click)="addNewStep(i)">
      {{ 'New Step' | translate }}
      <ion-icon slot="start" color="primary" name='add-circle-outline'></ion-icon>
    </ion-button>
  </div>
</div>
</div>


